import { useRef, useState, useCallback, useEffect } from "react";
import HeroBar from "../../Components/HeroBar/HeroBar";
import PlanSlider from "../../Components/PricingSection/PlanSlider/PlanSlider";
import CustomPlan from "../../Components/PricingSection/CustomPlan/CustomPlan";
import SaveBig from "../../Components/PricingSection/SaveBig/SaveBig";
import StartingCustomPlan from "../../Components/PricingSection/StartingCustomPlan/StartingCustomPlan";
import PricingFAQs from "../../Components/PricingSection/PricingFAQs/PricingFAQs";

const PricingPage = ({ pricingData, country, currency }) => {
  const saveBigRef = useRef(null);
  const heroRef = useRef(null);
  const planSliderSectionRef = useRef(null);
  const [selectedPlanName, setSelectedPlanName] = useState("");
  const [isYearly, setIsYearly] = useState(false);

  const handleGoToSaveBig = useCallback((planName) => {
    setSelectedPlanName(planName || "");
    if (saveBigRef.current) {
      saveBigRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);
  const handleGoToTop = () => {
    if (heroRef.current) {
      heroRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    const node = planSliderSectionRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            document.body.classList.remove("hide-rex-widget");

            const btn = document.getElementById("agentButton");
            if (btn) {
              btn.style.display = "block";
            }

            if (window.REX?.show) {
              window.REX.show();
            }
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <div ref={heroRef} >
        <HeroBar title={pricingData?.title} subtitle={pricingData?.subtitle} />
      </div>

      <StartingCustomPlan country={country} />
      <div ref={planSliderSectionRef}>
        <PlanSlider
          country={country}
          currency={currency}
          onGoToSaveBig={handleGoToSaveBig}
          isYearly={isYearly}
          onToggleBilling={() => setIsYearly((v) => !v)}
        />
      </div>
      <CustomPlan onGoToTop={handleGoToTop} />
      <div ref={saveBigRef}>
        <SaveBig
          planName={selectedPlanName}
          billing={isYearly ? "yearly" : "monthly"}
        />
      </div>
      <PricingFAQs />
    </div>
  );
};

export default PricingPage;
